import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { AIIllustration } from "@dreamhub/designsystem/icons";

interface Props {
  tPrefix: string;
  isOpenAlerts: boolean;
}

const EmptyAlerts: React.FC<Props> = ({ tPrefix, isOpenAlerts }) => {
  const { t } = useTranslation();

  return (
    <div className="p-2 flex flex-col gap-2 items-center">
      <AIIllustration />
      <Text variant="bodyTertiary">
        {t(`${tPrefix}.emptyAlerts`, {
          openOrClosed: isOpenAlerts ? "open" : "closed"
        })}
      </Text>
    </div>
  );
};

export default EmptyAlerts;
